import React from 'react';
import {
  Card, Typography,
} from 'antd';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
  Title
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
// import dayjs from 'dayjs';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
  ChartDataLabels,
  Title
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },

    // title: {
    //   display: true,
    //   text: 'Revenue',
    // },
  },
  maintainAspectRatio: false,
  // scales: {
  //   x: {
  //     grid: {
  //       offset: false
  //     }
  //   }
  // }
};

function DashboardBarchart({ revenue }) {

  // console.log(dayjs().year());
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        type: 'bar',
        label: revenue[0]['year'],
        data: revenue[0]['revenue'],
        // data: [66000, 73990, 67990, 65700, 66700, 56000, 76560, 69000, 88000, 78900, 76800, 88700],
        backgroundColor: '#ffb347',
        borderColor: 'white',
        // grouped:false,
        // borderWidth: 2,
        // borderRadius:20,
        // categoryPercentage: 0.5,
        // barPercentage: 1,
        datalabels: {
          labels: {
            title: null
          },
          anchor: 'top',
          align: 'top',
          offset: 0,
          formatter: function (value, context) {
            value = value.toString();
            value = value.split(/(?=(?:...)*$)/);
            value = value.join(',');
            return value;

          }
        }
      },
      {
        type: 'bar',
        label: revenue[1]['year'],
        data: revenue[1]['revenue'],
        // data: [76900, 79990, 76990, 66500, 66700, 56900, 77060, 96000, 89000, 89700, 78900, 99700],
        backgroundColor: '#483d8b',
        borderColor: 'white',
        // grouped:false,
        // borderWidth: 2,
        // borderRadius:20,
        // categoryPercentage: 0.5,
        // barPercentage: 1,
        datalabels: {
          labels: {
            title: null
          }
        },
      },
    ],
  };

  return (
    <div className='dasboardcard-container'>
      <Typography.Title
        level={5}
        style={{ margin: 0, padding: 0, color: '#483D8B' }}
      >
        Revenue
      </Typography.Title>
      <Card
        bordered={false}
        bodyStyle={{
          background: '#f7f7f7',
          border: '1px solid #f2f2f2',
          borderRadius: "8px",
          minHeight: '350px'
        }}
      >

        <Chart data={data} options={options} plugins={[ChartDataLabels]} />
      </Card>
    </div>
  )
}

export default DashboardBarchart